import styled from 'styled-components'
const SearchWrap = styled.div`
    width: 100%;
    padding-left: 0.32rem;
    padding-right: 0.32rem;
    height: 0.8rem;
    .main_search{
        height: 0.56rem;
        border-width: 1px;
        border-color: rgb(250, 44, 25);
        border-style: solid;
        border-radius: 0.12rem;
        background: #fff;
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        padding-right: 0.1rem;
        .search_icon{
            width: 0.3rem;
            height: 0.3rem;
            margin-left: 0.2rem;
        }
        .clear_icon{
            width: 0.25rem;
            height: 0.25rem;
            margin-right: 0.15rem;
        }
        .search_btn{
            font-size: 0.25rem;
            width: 0.9rem;
            height: 0.4rem;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            border-radius: 0.12rem;
            background-image: linear-gradient(405deg, rgb(255, 69, 113) 7.85046e-15%, rgb(250, 44, 25) 100%);
        }
    }
    .search_input{
        height: 0.32rem;
        flex: 1;
        font-size: 0.24rem;
        margin-left: 0.1rem;
        background: transparent
    }
`
export {SearchWrap}